import { useIntl } from 'bundles/page/lib/useIntl';

import _t from 'i18n!nls/program-loggedin-shared';

export const useCategoryCompletionRule = (minUnits: number) => {
  const intl = useIntl();
  return intl.formatMessage(_t('Complete {minUnits, plural, =0 {0 segments} =1 {1 segment} other {# segments}}'), {
    minUnits,
  });
};

export const useSegmentCompletionRule = (minUnits: number) => {
  const intl = useIntl();
  return intl.formatMessage(_t('{minUnits, plural, =0 {0 credits} =1 {1 credit} other {# credits}} required'), {
    minUnits,
  });
};
